/**
 * URL utility functions
 * Author - AI Assistant
 */

/**
 * Adds a query parameter to the current URL while preserving hash fragments
 * @param {string} paramName - The name of the query parameter
 * @param {string|boolean|number} paramValue - The value of the query parameter
 */
export const addQueryParamToUrl = (paramName, paramValue) => {
  const currentUrl = window.location.href;
  const [baseUrl, hash] = currentUrl.split("#");
  const url = new URL(baseUrl);
  url.searchParams.set(paramName, paramValue.toString());
  const newUrl = hash ? `${url.toString()}#${hash}` : url.toString();
  window.history.replaceState({}, "", newUrl);
};

/**
 * Adds validArn query parameter to the current URL
 * @param {boolean} validArn - Whether the ARN is valid or not
 */
export const addValidArnQueryParam = (validArn) => {
  addQueryParamToUrl("validArn", validArn);
};
